import SummaryLoading from "./SummaryLoading";

export default SummaryLoading;
